import Day from './Day.jsx'

export default Day
